import React from "react";
import './styles.css';
export default class ScalerChart extends React.Component {
  render() {
    return (
      <div className="row">
        <div className={this.props.Cstyle}>
          <p>{this.props.title}</p>
          <h4>{this.props.value}</h4>
          <p>{this.props.unit}</p>
        </div>
      {/* </div> */}
      </div>
    
    );
  }
}
